module.exports = __webpack_public_path__ + "static/img/case-2duikang.aa7222f9.jpg";